export const testimonials = [
  {
    quote: "We swapped our entire visual identity in an afternoon. Every token flowed through, nothing broke.",
    name: 'Sana Iqbal',
    role: 'Founder, Ledgerly',
  },
  {
    quote: "The interactive mockups did more for our waitlist conversion than any line of copy we tested.",
    name: 'Tom Whitfield',
    role: 'Head of Growth, Ampere',
  },
  {
    quote: "Solvora gave our three-person team a launch page that looked like it came from an in-house design org.",
    name: 'Renata Cole',
    role: 'Co-founder, Field Notes',
  },
];
